/* eslint-disable */
import axios from "axios";
import store from "../../store/index";
import customModal from "../customModal/customModal.vue";
import Multiselect from "@vueform/multiselect";

export default {
  name: "linkSite",
  components: {
    customModal,
    Multiselect,
    
  },
  emits: ["close", "save"],
  props: {
    labCode: {
      type: String,
      required: true,
    },
//     testCode: {
//       type: String,
//       required: true,
//     },
    studyId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      selectedSite: "",
      hideSelected: false,
      selectedSites : [],
        localLabCode: "",

      siteList: [],
     studyId: store.getters.getStudyIs,
      baseurl: process.env.VUE_APP_Service_URL,
      token: "",
      errors: [],
    };
  },
  async mounted() {
    this.token = store.getters.getIdToken;
      this.studyId = store.getters.getStudyIs
       this.localLabCode = this.labCode;
    await this.fetchSiteList();
   
  },
  methods: {
async fetchSiteList() {
    const lab = this.localLabCode || this.labCode;
  try {
    const response = await axios.get(
      `${this.baseurl}/management/labsiteassignment/labsiteassignedlist?StudyId=${this.studyId}&LabCode=${lab}`,
      {
        headers: {
          Authorization: `Bearer ${this.token}`,
        },
      }
    );

    const assigned = response.data?.assignedSites?.results || [];
    const allSites = response.data?.allSites?.results || [];

    // Extract site codes of assigned sites
    const assignedCodes = assigned.map(site => site.siteCode);

    // Build dropdown list
    this.siteList = allSites.map(site => ({
      label: site.siteCode,
      value: site.siteCode,
      siteId: site.siteId,
      labCode: site.labCode,
    }));

    this.selectedSites = [...assignedCodes];

  } catch (error) {
    console.error("Failed to fetch site list:", error);
    this.siteList = [];
  }
},




    onSiteChange() {
      this.selectedSite = this.selectedSite.trim();
    },

    validate() {
      this.errors = [];
      if (!this.selectedSites) {
        this.errors.push(this.$t("navigations.site code") + " is required.");
      }
      return this.errors.length === 0;
    },

async saveLinkedSite() {
  if (!this.validate()) {
    alert(this.errors.join("\n"));
    return;
  }

  try {
    let payload;
    
    if (this.selectedSites.length === 0) {
      // Remove all sites - send the specific payload structure with empty values
      payload = {
        labSiteAssignments: [
          {
            siteCode: "",
            siteId: "",
            studyId: this.studyId,
            labCode: this.labCode,
            assignedTests: [{}], // Empty object in array
            status: ""
          }
        ]
      };
      console.log("Remove sites payload:", payload);
    } else {
      // Assign sites - send normal payload with selected sites
      payload = {
        labSiteAssignments: this.selectedSites.map(siteCode => ({
          siteCode: siteCode,
          siteId: this.siteList.find(s => s.value === siteCode)?.siteId || "",
          studyId: this.studyId,
          labCode: this.labCode,
          assignedTests: [],
          effectiveDate: new Date().toISOString(),
          status: "Active",
        })),
      };
      console.log("Assign sites payload:", payload);
    }

    await axios.post(
      `${this.baseurl}/management/labsiteassignment/createlabsiteassignment`,
      payload,
      {
        headers: {
          Authorization: `Bearer ${this.token}`,
          "Content-Type": "application/json",
        },
      }
    );

    if (this.selectedSites.length === 0) {
      alert("All sites have been successfully unassigned from the lab.");
    } else {
      alert(`Lab has been successfully assigned to ${this.selectedSites.length} site(s).`);
    }
    
    this.$emit("save");
    this.$emit("close");
  } catch (err) {
    console.error("API Error:", err);
    
    let errorMessage = "Failed to process lab-site assignment. Please try again.";
    
    if (this.selectedSites.length === 0) {
      errorMessage = "Failed to unassign sites from the lab. Please try again.";
    }

    if (err.response?.data) {
      console.error("Server validation error:", err.response.data);
      
      // Handle different error response formats
      if (err.response.data.messages?.length) {
        errorMessage = err.response.data.messages[0];
      } else if (err.response.data.detail) {
        errorMessage = err.response.data.detail;
      } else if (err.response.data.errors) {
        const errorList = Object.values(err.response.data.errors)
          .flat()
          .join("\n");
        errorMessage = errorList || errorMessage;
      } else if (err.response.data.title) {
        errorMessage = err.response.data.title;
      }
    } else if (err.request) {
      errorMessage = "Network error: Unable to connect to server. Please check your connection.";
    } else {
      errorMessage = "An unexpected error occurred. Please try again.";
    }

    alert(errorMessage);
  }
}


  },
};
